import styled from "styled-components";

export const MyDiv = styled.div`

 .jobTitle{
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }
    
 .pulse {
    height: 40px;
    width: 40px;
   
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
}

.pulse::before,
.pulse::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid #006838;
    animation: pulse 1.5s linear infinite;
}

.pulse::after {
    animation-delay: 0.5s;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 0.7;
    }
    70% {
        transform: scale(1.8);
        opacity: 0;
    }
    100% {
        transform: scale(1.8);
        opacity: 0;
    }
}
.pulse img {
    animation: vibrate 0.6s ease-in-out infinite;
}

@keyframes vibrate {
    0%,100% { transform: rotate(0deg); }
    25% { transform: rotate(-8deg); }
    75% { transform: rotate(8deg); }
}
 



  .flex_header{
    align-items: center;
    justify-content: space-between;
}

    .filter_section {
    display: flex;
    gap: 10px;
  }

.btn {
    background: rgba(0, 104, 56, 1);
    color: white;
    &:hover {
      background: rgba(0, 104, 56, 0.9);
      color: white;
    }
  
 .card_box {
  background: white;
  border-radius: 12px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));

}
  .donut-chart {
    width: 280px;
    height: 299px;
  }
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.notification-button{
    column-gap: 10px;
    padding: 5px 10px;
}
.avatar-icon{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.avatar-icon .chakra-avatar__initials{
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
}
.accordion-scroll{
    height: 280px;
    overflow-y: scroll;
}
    
.view{
  text-decoration: underline;
  color: #006838;
  cursor: pointer;
  }
  
`



export const CallModal = styled.div`

.pulse {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
}

.pulse::before,
.pulse::after {
    content:"";
    position:absolute;
    inset:0;
    border-radius:50%;
    border:2px solid #006838;
    animation:pulse 1.5s linear infinite;
}

.pulse::after {
    animation-delay:.5s;
}

@keyframes pulse {
    0% { transform:scale(1); opacity:.7 }
    70% { transform:scale(1.8); opacity:0 }
    100% { transform:scale(1.8); opacity:0 }
}

.pulse img {
    animation:vibrate .6s ease-in-out infinite;
}

@keyframes vibrate {
    0%,100% { transform:rotate(0deg) }
    25% { transform:rotate(-8deg) }
    75% { transform:rotate(8deg) }
}
`;


